import { Modal } from "flowbite-react";
import { FaCheckCircle } from "react-icons/fa";

type Props = {
  open: boolean
  onClosed: () => void;
}

export default function ModalSuccessRegisterIndicator(props: Props) {
  const handleCloseModal = () => { props.onClosed && props.onClosed() }

  return (
    <Modal
      className="relative"
      show={props.open}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">

        <div className="flex items-baseline justify-center bg-gray-100">
          <span className="text-md mb-4"><FaCheckCircle className="text-greenPrimary" /></span>
          <h2 className="ml-2 text-black">Cadastro realizado com sucesso!</h2>
        </div>
      </Modal.Header>
      <Modal.Body className="dark:text-black">
        <div className="flex items-center justify-center bg-gray-100">
          <h2 className="text-2xl font-semibold mb-4"></h2>
        </div>
        <div className="flex items-center justify-center bg-gray-100">
          <span className="text-md ml-2 mb-4"> Por favor, verificar <strong>seu e-mail</strong> para validação do seu cadastro</span>
        </div>
      </Modal.Body>
    </Modal>
  );
}